import { put, takeEvery, takeLatest } from "redux-saga/effects";
import { dotXetChungChiApi } from "../../../api/xet-chung-chi/dotXetChungChiApi";
import { IBaseResponse } from "../../../model/response/IBaseResponse";
import { toLowerCaseDeep } from "../../../utils/toLowerCaseDeep";
import { eDotXetChungChiActionIds, IDotXetChungChiActionTypes } from "../../action-types/xet-chung-chi/IDotXetChungChiActions";
import { rootActions } from "../../actions/rootActions";
import { IDotXetChungChi } from "../../../model/response/xet-chung-chi/IDotXetChungChi";

const mainActions = rootActions.xetChungChi.dotXetChungChi;

export function* dotXetChungChiSaga(): any {
    yield takeLatest(eDotXetChungChiActionIds.LOAD_START, loadWorker);
    yield takeEvery(eDotXetChungChiActionIds.SAVE_START, saveWorker);
    yield takeEvery(eDotXetChungChiActionIds.DELETE_START, deleteWorker);
}

function* loadWorker(action: IDotXetChungChiActionTypes): any {
    const response: IBaseResponse = yield dotXetChungChiApi.SelectAll();
    if (response.is_success) {
        yield put(mainActions.LOAD_SUCCESS(toLowerCaseDeep(response.data)));
    } else {
        yield put(mainActions.LOAD_ERROR(response.message ?? "Không thể tải danh sách đợt xét chứng chỉ"));
    }
}

function* saveWorker(action: IDotXetChungChiActionTypes): any {
    const payload = action.payload as IDotXetChungChi;
    let response: IBaseResponse;
    if (payload.id_dot_xet > 0) {
        response = yield dotXetChungChiApi.Update(payload.id_dot_xet, payload);
    } else {
        response = yield dotXetChungChiApi.Insert(payload);
    }

    if (response.is_success) {
        yield put(mainActions.SAVE_SUCCESS(response.data));
    } else {
        yield put(mainActions.SAVE_ERROR(response.message ?? "Có lỗi khi lưu đợt xét chứng chỉ"));
    }
}

function* deleteWorker(action: IDotXetChungChiActionTypes): any {
    const id = action.payload as number;
    const response: IBaseResponse = yield dotXetChungChiApi.Delete(id);
    if (response.is_success) {
        yield put(mainActions.DELETE_SUCCESS(response.data));
    } else {
        yield put(mainActions.DELETE_ERROR(response.message ?? "Có lỗi khi xóa đợt xét chứng chỉ"));
    }
}